// src/utils/utils1.js

export function logout(router) {
  // Clear the token from localStorage
  localStorage.removeItem("token");

  // Redirect the user to the login page
  router.push("/");

  // Reload the window (optional, depending on your application needs)
  window.location.reload();
}

export function getOauthToken() {
  return localStorage.getItem("token");
}
export function getCareAuthToken() {
  return localStorage.getItem("token2");
}

export function getQuoteById(quotes, quoteId) {
  // Ensure the input is an array
  if (!Array.isArray(quotes)) {
    console.error("Invalid data structure: Expected an array.");
    return null;
  }

  // Search for the object with the matching id
  const quote = quotes.find((order) => order.id == quoteId);

  // Return the found item or null if no match
  return quote || null;
}

/*
const searchKey = 'displayName';  // The key you want to search by
    const searchValue = 'The Cannon Group PLC'; // The value you're looking for
    const returnKey = 'id'; // The key whose value you want to return

    const result = getValueByKey(this.jsonArray, searchKey, searchValue, returnKey);
*/

// Utility function to search for a value based on a key-value pair and return another value
export function getValueByKey(jsonArray, searchKey, searchValue, returnKey) {
  for (let item of jsonArray) {
    // Check if the item has the searchKey and the value matches the searchValue
    if (item[searchKey] && item[searchKey] === searchValue) {
      // Return the corresponding value for the returnKey
      return item[returnKey];
    }
  }
  // Return null if no match is found
  return null;
}
